import axios from 'axios';
import constants from '../../config/constants';

export const GET_ALL_SUBJECTS = 'GET_ALL_SUBJECTS';
export const GET_SCHOOL_SUBJECTS = 'GET_SCHOOL_SUBJECTS';
export const GET_SUBJECT = 'GET_SUBJECT';
export const GET_COURSE_SUBJECTS = 'GET_COURSE_SUBJECTS';
export const GET_EMP_SUBJECTS = 'GET_EMP_SUBJECTS';
export const GET_UN_ASSIGNED_SUBJECTS = 'GET_UN_ASSIGNED_SUBJECTS';

//= ========== Reducer call functions begin ===========//
export const getAllSubjects = subjectData => ({
  type: GET_ALL_SUBJECTS,
  subjectData,
});

export const getSchoolSubjects = subjects => ({
  type: GET_SCHOOL_SUBJECTS,
  subjects,
});

export const getEmpSubjects = empSubjects => ({
  type: GET_EMP_SUBJECTS,
  empSubjects,
});

export const getSubject = subject => ({
  type: GET_SUBJECT,
  subject,
});

export const getCourseSubjects = subjects => ({
  type: GET_COURSE_SUBJECTS,
  subjects,
});

export const getUnAssigedSchoolSubjects = unAssignedSubjects => ({
  type: GET_UN_ASSIGNED_SUBJECTS,
  unAssignedSubjects,
});
//= ========== Reducer call functions begin ===========//

//= ========== User routing begin ===========//
export const fetchAllSubjectsService = data => async dispatch => {
  const url =
    constants.API_BASE_URL +
    (!data?.batchId
      ? `/api/admin/get-batch-subject-by-page/${data.schoolId}/${data.batchId}`
      : `/api/admin/get-school-subject-by-page/${data.schoolId}`) +
    constants.makeParams(data.pageParams);
  try {
    const res = await axios.get(url, constants.setHeader(data.token));
    return dispatch(getAllSubjects(res.data));
  } catch (err) {
    console.error(err.response);
  }
};

export const fetchSchoolSubjectsService = data => async dispatch => {
  try {
    const res = await axios.get(
      `${constants.API_BASE_URL}/api/admin/get-school-subject/${data.schoolId}`,
      constants.setHeader(data.token)
    );
    dispatch(getSchoolSubjects(res.data));
  } catch (err) {
    console.error(err.response);
  }
};

export const fetchUnAssigedSchoolSubjectsService = data => async dispatch => {
  const url = `/api/admin/get-batch-unassigned-subject/${data.schoolId}/${data.batchId}`;
  try {
    const res = await axios.get(`${constants.API_BASE_URL}${url}`, constants.setHeader(data.token));
    dispatch(getUnAssigedSchoolSubjects(res.data));
  } catch (err) {
    console.error(err.response);
  }
};

export const saveSubjectService = data => () => {
  const url = `/api/admin/create-multiple-subject/${data?.courseId}`;
  return axios.post(`${constants.API_BASE_URL}${url}`, data.postData, constants.setHeader(data.token));
};

export const fetchSubjectService = data => async dispatch => {
  try {
    const res = await axios.get(
      `${constants.API_BASE_URL}/api/admin/get-subject/${data.subjectId}`,
      constants.setHeader(data.token)
    );
    return dispatch(getSubject(res.data));
  } catch (err) {
    console.error(err.response);
  }
};

export const updateSubjectService = data => () => {
  return axios.put(
    `${constants.API_BASE_URL}/api/admin/update-subject/${data.subjectId}`,
    data.postData,
    constants.setHeader(data.token)
  );
};

export const deleteSubjectService = data => () => {
  return axios.delete(
    `${constants.API_BASE_URL}/api/admin/delete-subject/${data.subjectId}`,
    constants.setHeader(data.token)
  );
};

export const fetchEmployeeSubjectsService = data => async dispatch => {
  try {
    const res = await axios.get(
      `${constants.API_BASE_URL}/api/employee/subject/${data.employeeId}`,
      constants.setHeader(data.token)
    );
    dispatch(getEmpSubjects(res.data));
    return res.data;
  } catch (err) {
    console.error(err.response);
  }
};

export const fetchCourseSubjectsService = data => async dispatch => {
  try {
    const res = await axios.get(
      `${constants.API_BASE_URL}/api/student/subject/${data.courseId}`,
      constants.setHeader(data.token)
    );
    dispatch(getCourseSubjects(res.data));
    return res.data;
  } catch (err) {
    console.error(err.response);
  }
};

// The teacher currently assigned to a subject (null if none) - used by the "Assign
// Teacher Subject" action on the Subjects page. Not dispatched to the store, this is
// only ever needed transiently while a specific AssignTeacherSubjectModal is open.
export const fetchTeacherBySubjectApi = data => {
  return axios.get(
    `${constants.API_BASE_URL}/api/admin/teacher-subject/${data.subjectId}`,
    constants.setHeader(data.token)
  );
};

// Teachers with no subject assigned yet school-wide - populates the picker in
// AssignTeacherSubjectModal.
export const fetchUnassignedTeachersApi = data => {
  return axios.get(
    `${constants.API_BASE_URL}/api/admin/unassigned-teachers?schoolId=${data.schoolId}`,
    constants.setHeader(data.token)
  );
};
//= ========== User routing end ===========//
